import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import Learn from "@/pages/Learn";
import Support from "@/pages/Support";
import DeleteAccount from "@/pages/DeleteAccount";
import { Navigate } from "react-router-dom";
import CalcPage from "@/pages/calculators/CalcPage";
import { CALCULATOR_PAGES } from "@/pages/calculators/configs";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/support" element={<Support />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/delete-my-account" element={<Navigate to="/delete-account" replace />} />
          <Route path="/account-deletion" element={<Navigate to="/delete-account" replace />} />
          <Route path="/data-deletion" element={<Navigate to="/delete-account" replace />} />
          {CALCULATOR_PAGES.map((c) => (
            <Route key={c.path} path={c.path} element={<CalcPage config={c} />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
